<template>
  <div class="map">
    <div class="map-main">
      <div class="map-main-title">Find a Retailer</div>
      <div class="map-main-search">
        <el-input placeholder="City, Postcode Country" v-model="search"
          @change="$router.push({path:'/map',query:{keyword:search}})" class="input-with-select">
          <el-button slot="append" icon="el-icon-search" style="font-size: .35rem;"
            @click="$router.push({path:'/map',query:{keyword:search}})"></el-button>
        </el-input>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'footerbar',
    data() {
      return {
        search: ''
      }
    }
  }
</script>

<style lang="scss" scoped>
  .map {
    height: 4.83rem;
    width: 100%;
    background-image: url('../../assets/images/component/thinkgrow_homepage_map.png');
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;

    &-main {
      width: 14.4rem;
      margin: auto;
      padding-top: .9em;
      text-align: center;

      &-title {
        font-size: 0.48rem;
        padding-top: 1.78rem;
        margin-bottom: 0.3rem;
      }

      &-search {
        margin: auto;
        width: 5.88rem;

        >>>.el-input-group--append .el-input__inner {
          height: 0.5rem;
        }
      }
    }

    .input-with-select {
      font-size: 0.2rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/layout/component/Mapbar.vue